import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withMessages from 'component-utilities/intl';
import styles from './Findtool.scss';

@withMessages
class Findtool extends Component {
    static propTypes = {
        getMessage: PropTypes.func.isRequired,
        placeholder: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    static defaultProps = {
        onClose: () => {},
    };

    constructor(props) {
        super(props);

        this.state = { isChecked: false };
    }

    setOpen = () => {
        this.setState({ isChecked: true }, () => {
            $('[data-field="search-input"]').focus();
        });
    };

    close = () => {
        this.setState({ isChecked: false });
        this.props.onClose();
    };

    render() {
        const { getMessage, placeholder, value, onChange } = this.props;

        return (
            <div data-field="find-tool" className={styles.findtool}>
                <input
                    className={styles['findtool-input-hidden']}
                    checked={this.state.isChecked}
                    onChange={() => {}}
                    type="checkbox"
                />
                <label htmlFor="findtool" className={styles['findtool-label']}>
                    <span role="presentation" onClick={this.setOpen} className={styles['findtool-find']}>
                        {getMessage('components.action_buttons.find_tool.label')}
                    </span>
                    <span
                        role="presentation"
                        className={styles['findtool-close']}
                        data-action="close"
                        onClick={this.close}
                    />
                </label>
                <div className={styles['findtool-field']}>
                    <input
                        className={styles['findtool-input-field']}
                        data-field="search-input"
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        type="text"
                    />
                </div>
            </div>
        );
    }
}

export default Findtool;
